import _sfc_main from './list-wrapper.vue.js';
/* empty css                  */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const listWrapper = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-bd7d800d"]]);

export { listWrapper as default };
//# sourceMappingURL=list-wrapper.js.map
